module.exports = __webpack_public_path__ + "static/media/web_miniwordpress.4875c05c.png";